<div class="container" id="event-details-page">
  <div class="content">
    <div class="template-main-content">
      <!-- Left Sidebar Navigation -->
      <div class="side-nav neo-scrollbar" id="event-details-sidebar">
        <div class="neo-tabs vertical" id="event-details-tabs">
          <div class="neo-tab" id="event-details-tab-overview" [class.active]="currentTab() === 'overview'"
            (click)="switchCurrentTab('overview')">
            <img src="assets/icons-svg/menu-board.svg" alt="Overview" class="tab-icon">
            Overview
          </div>
          <div *ngIf="userPrivileges.has('job_role.view')" class="neo-tab" id="event-details-tab-job-roles" [class.active]="currentTab() === 'job-roles'"
            (click)="switchCurrentTab('job-roles')">
            <img src="assets/icons-svg/user-edit.svg" alt="Job Roles" class="tab-icon">
            Job Roles
          </div>
          <div *ngIf="userPrivileges.has('event_access_management.view')" class="neo-tab" id="event-details-tab-access-management" [class.active]="currentTab() === 'access-management'"
            (click)="switchCurrentTab('access-management')">
            <img src="assets/icons-svg/hierarchy.svg" alt="Access Management" class="tab-icon">
            Access Management
          </div>
        </div>
      </div>

      <!-- Right Content Area -->
      <div class="template-details" id="event-details-content">
        <!-- Right-side Loading Overlay -->
        <div *ngIf="isLoading && !showAssignUserDialog" class="right-loading-overlay center-loader">
    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
    </p-progressSpinner>
        </div>
        <!-- Overview Tab -->
        @if (currentTab() === "overview") {
        <div class="template-content neo-scrollbar" id="event-details-overview-tab">
          <!-- Event Details Section -->
          <div class="section" id="event-details-section">
            <div class="section-heading" id="event-details-section-heading">
              Event Details
            </div>
            <div class="section-content" id="event-details-section-content">
              <div class="section-item no-border">
                <div class="section-item-content" [formGroup]="eventDetailsForm" *ngIf="!isLoading">
                  <div class="neo-input-wrapper" id="event-details-name-wrapper">
                    <label for="event_name">Event Name <span class="required">*</span></label>
                    <input pInputText type="text" name="event_name" id="event-details-name-input"
                      [readonly]="!userPrivileges.has('event.update')" 
                      formControlName="eventTitle"
                      [ngClass]="{'error': clicked && eventDetailsForm.controls['eventTitle'].errors}">
                    <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('eventTitle')" name="Event title"></app-handle-error>
</div>

                  <div class="neo-grid neo-grid-cols-2" id="event-details-category-type-grid">
                    <div class="neo-input-wrapper" id="event-details-category-wrapper">
                      <label for="event_category">Event Category <span class="required">*</span></label>
                      <p-select 
                        [options]="eventCategories" 
                        formControlName="eventCategory"
                        optionLabel="name" 
                        optionValue="id"
                        [disabled]="!userPrivileges.has('event.update')"
                        [filter]="true"
                        [filterBy]="'name'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['eventCategory'].errors}"
                        placeholder="Choose an event category"
                        appendTo="body"
                        #eventCategory
                        [panelStyle]="{
                            'min-width': eventCategory.el.nativeElement.offsetWidth + 'px',
                            'max-width': eventCategory.el.nativeElement.offsetWidth + 'px'
                        }"
                        id="event-details-category-dropdown">
                      </p-select>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('eventCategory')" name="Event category"></app-handle-error>
                    </div>
                    <div class="neo-input-wrapper" id="event-details-type-wrapper">
                      <label for="event_type">Event Type <span class="required">*</span></label>
                      <p-select 
                        [options]="eventTypes" 
                        formControlName="eventType"
                        optionLabel="name" 
                        optionValue="id"
                        (onChange)="onEventTypeChange()"
                        [disabled]="!userPrivileges.has('event.update')"
                        [filter]="true"
                        [filterBy]="'name'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['eventType'].errors}"
                        appendTo="body"
                        #eventType
                        [panelStyle]="{
                            'min-width': eventType.el.nativeElement.offsetWidth + 'px',
                            'max-width': eventType.el.nativeElement.offsetWidth + 'px'
                        }"
                        placeholder="Choose an event type"
                        id="event-details-type-dropdown">
                      </p-select>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('eventType')" name="Event type"></app-handle-error>
                    </div>
</div>

                  <div class="neo-grid neo-grid-cols-2" id="event-details-dates-grid">
                    <div class="neo-input-wrapper" id="event-details-start-date-wrapper">
                      <label for="event_start_date">Event Start Date <span class="required">*</span></label>
                      <p-datepicker 
                        iconDisplay="input"
                        inputId="event-details-start-date" 
                        formControlName="eventStartDate"
                        [maxDate]="eventDetailsForm.get('eventEndDate')?.value || null"
                        [showIcon]="true"
                        [readonlyInput]="!userPrivileges.has('event.update')"
                        [showTime]="true"
                        [hourFormat]="'12'" appendTo="body" [panelStyleClass]="'filter-date-range'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['eventStartDate'].errors}"
                        placeholder="Select a date"
                        id="event-details-start-date-calendar"
                        [style]="{'--p-anchor-gutter': '0px'}"
                        styleClass="event-start-date-calendar">
                      </p-datepicker>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('eventStartDate')" name="Event start date"></app-handle-error>
                    </div>
                    <div class="neo-input-wrapper" id="event-details-end-date-wrapper">
                      <label for="event_end_date">Event End Date <span class="required">*</span></label>
                      <p-datepicker 
                        iconDisplay="input"
                        inputId="event-details-end-date" 
                        formControlName="eventEndDate"
                        [minDate]="eventDetailsForm.get('eventStartDate')?.value || null"
                        [showIcon]="true"
                        [readonlyInput]="!userPrivileges.has('event.update')"
                        [showTime]="true"
                        [hourFormat]="'12'" appendTo="body" [panelStyleClass]="'filter-date-range'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['eventEndDate'].errors}"
                        placeholder="Select a date"
                        id="event-details-end-date-calendar"
                        [style]="{'--p-anchor-gutter': '0px'}"
                        styleClass="event-end-date-calendar">
                      </p-datepicker>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('eventEndDate')" name="Event end date"></app-handle-error>
                    </div>
</div>

                  <div class="neo-grid neo-grid-cols-2" id="event-details-registration-dates-grid">
                    <div class="neo-input-wrapper" id="event-details-reg-start-date-wrapper">
                      <label for="registration_start_date">Registration Start Date <span class="required">*</span></label>
                      <p-datepicker 
                        iconDisplay="input"
                        inputId="event-details-reg-start-date" 
                        formControlName="registrationStartDate"
                        [maxDate]="eventDetailsForm.get('registrationEndDate')?.value || eventDetailsForm.get('eventEndDate')?.value || null"
                        [showIcon]="true"
                        [readonlyInput]="!userPrivileges.has('event.update')"
                        [showTime]="true"
                        [hourFormat]="'12'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['registrationStartDate'].errors}"
                        placeholder="Select a date" appendTo="body" [panelStyleClass]="'filter-date-range'"
                        id="event-details-reg-start-date-calendar">
                      </p-datepicker>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('registrationStartDate')" name="Registration start date"></app-handle-error>
                    </div>
                    <div class="neo-input-wrapper" id="event-details-reg-end-date-wrapper">
                      <label for="registration_end_date">Registration End Date <span class="required">*</span></label>
                      <p-datepicker 
                        iconDisplay="input"
                        inputId="event-details-reg-end-date" 
                        formControlName="registrationEndDate"
                        [minDate]="eventDetailsForm.get('registrationStartDate')?.value || null"
                        [maxDate]="eventDetailsForm.get('eventEndDate')?.value || null"
                        [showIcon]="true"
                        [readonlyInput]="!userPrivileges.has('event.update')"
                        [showTime]="true" appendTo="body" [panelStyleClass]="'filter-date-range'"
                        [hourFormat]="'12'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['registrationEndDate'].errors}"
                        placeholder="Select a date"
                        id="event-details-reg-end-date-calendar">
                      </p-datepicker>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('registrationEndDate')" name="Registration end date"></app-handle-error>
                    </div>
    </div>
                  
                  <div class="neo-grid neo-grid-cols-2" id="event-details-institution-grid" *ngIf="eventDetailsForm.value.eventType">
                    <div class="neo-input-wrapper" id="event-details-institution-name-wrapper">
                      <label for="institution_name">Institution Name 
                        <span class="required" *ngIf="getSelectedEventType()?.institution_select_type !== 'not_applicable'">*</span>
                      </label>
                        <ng-container *ngIf="getSelectedEventType()?.institution_select_type !== 'single'; else singleSelect">
                         <p-multiselect 
                           [options]="institutions" 
                           formControlName="institutionName"
                           optionLabel="name" 
                           optionValue="id"
                           [disabled]="!userPrivileges.has('event.update')"
                           [ngClass]="{'error': clicked && eventDetailsForm.controls['institutionName'].errors}"
                           placeholder="Select institutions"
                           display="chip"
                           [filter]="true"
                           [filterBy]="'name'"
                           appendTo="body"
                           [virtualScroll]="true" [virtualScrollItemSize]="43"
                          #institutionName
                          [panelStyle]="{
                              'min-width': institutionName.el.nativeElement.offsetWidth + 'px',
                              'max-width': institutionName.el.nativeElement.offsetWidth + 'px'
                          }"
                           [showClear]="true"
                           id="event-details-institution-multiselect">
                           <ng-template let-institution pTemplate="item">
                             <div [pTooltip]="institution.name" tooltipPosition="right" [tooltipStyleClass]="'custom-tooltip'">
                               {{ institution.name }}
                             </div>
                           </ng-template>
                         </p-multiselect>
    </ng-container>
                        <ng-template #singleSelect>
                         <p-select 
                           [options]="institutions" 
                           formControlName="institutionName"
                           optionLabel="name" 
                           optionValue="id"
                           [disabled]="!userPrivileges.has('event.update')"
                           [ngClass]="{'error': clicked && eventDetailsForm.controls['institutionName'].errors}"
                           placeholder="Select institution"
                           [filter]="true"
                           [filterBy]="'name'"
                           [showClear]="true"
                           appendTo="body"
                           [virtualScroll]="true" [virtualScrollItemSize]="43"
                           #institutionName
                          [panelStyle]="{
                              'min-width': institutionName.el.nativeElement.offsetWidth + 'px',
                              'max-width': institutionName.el.nativeElement.offsetWidth + 'px'
                          }"
                           id="event-details-institution-dropdown">
                           <ng-template let-institution pTemplate="item">
                             <span class="dropdown-item-content" [title]="institution.name">
                               {{ institution.name }}
                             </span>
                           </ng-template>
                         </p-select>
                        </ng-template>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('institutionName')" name="Institution name"></app-handle-error>
                    </div>
                    <div class="neo-input-wrapper" id="event-details-institution-address-wrapper">
                      <label for="institution_address">Institution Address 
                        <span class="required" *ngIf="getSelectedEventType()?.institution_select_type !== 'not_applicable'">*</span>
                      </label>
                      <input pInputText type="text" name="institution_address" id="event-details-institution-address-input"
                        [readonly]="!userPrivileges.has('event.update')" 
                        formControlName="institutionAddress"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['institutionAddress'].errors}">
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('institutionAddress')" name="Institution address"></app-handle-error>
                    </div>
                  </div>
                  
                  <div class="neo-input-wrapper" id="event-details-job-role-wrapper">
                    <label for="job_role">Job Role <span class="required">*</span></label>
                    <p-multiSelect 
                      [options]="jobRoles" 
                      formControlName="jobRole"
                      optionLabel="name" 
                      optionValue="id"
                      [disabled]="!userPrivileges.has('event.update')"
                      [filter]="true"
                      [showClear]="true"
                      [ngClass]="{'error': clicked && eventDetailsForm.controls['jobRole'].errors}"
                      placeholder="Select job roles"
                      display="chip"
                      appendTo="body"
                      #jobRole
                      [panelStyle]="{
                          'min-width': jobRole.el.nativeElement.offsetWidth + 'px',
                          'max-width': jobRole.el.nativeElement.offsetWidth + 'px'
                      }"
                      [overlayOptions]="{styleClass: 'event-details-job-role'}"
                      id="event-details-job-role-multiselect">
                    </p-multiSelect>
                    <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('jobRole')" name="Job role"></app-handle-error>
                  </div>
                </div>
                </div>
            </div>
        </div>

          <!-- Experience & Salary Details Section -->
          <div class="section" id="event-details-experience-section">
            <div class="section-heading" id="event-details-experience-section-heading">
              Experience & Salary Details
            </div>
            <div class="section-content" id="event-details-experience-section-content">
              <div class="section-item no-border">
                <div class="section-item-content" [formGroup]="eventDetailsForm">
                  <div class="neo-input-wrapper" id="event-details-work-experience-wrapper">
                    <label for="work_experience">Work Experience</label>
                    <input pInputText type="number" name="work_experience" id="event-details-work-experience-input"
                      [readonly]="!userPrivileges.has('event.update')" 
                      formControlName="workExperience">
                  </div>
                  
                  <div class="neo-grid neo-grid-cols-2" id="event-details-salary-grid">
                    <div class="neo-input-wrapper" id="event-details-min-salary-wrapper">
                      <label for="min_salary">Minimum Salary</label>
                      <input pInputText type="number" name="min_salary" id="event-details-min-salary-input"
                        [readonly]="!userPrivileges.has('event.update')" 
                        formControlName="minSalary">
                    </div>
                    <div class="neo-input-wrapper" id="event-details-max-salary-wrapper">
                      <label for="max_salary">Maximum Salary</label>
                      <input pInputText type="number" name="max_salary" id="event-details-max-salary-input"
                        [readonly]="!userPrivileges.has('event.update')" 
                        formControlName="maxSalary">
                    </div>
                  </div>
                </div>
                </div>
            </div>
        </div>

          <!-- Template Details Section -->
          <div class="section" id="event-details-template-section">
            <div class="section-heading" id="event-details-template-section-heading">
              Template Details
            </div>
            <div class="section-content" id="event-details-template-section-content">
              <div class="section-item no-border">
                <div class="section-item-content" [formGroup]="eventDetailsForm">
                  <div class="neo-grid neo-grid-cols-2" id="event-details-template-grid">
                    <div class="neo-input-wrapper" id="event-details-registration-form-wrapper">
                      <label for="registration_form">Registration Form <span class="required">*</span></label>
                      <p-select 
                        [options]="regForms" 
                        formControlName="reg_form_uuid"
                        optionLabel="name" 
                        optionValue="uuid"
                        [disabled]="!userPrivileges.has('event.update')"
                        [filter]="true"
                        [filterBy]="'name'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['reg_form_uuid'].errors}"
                        placeholder="Choose a registration form"
                        appendTo="body"
                        #reg_form_uuid
                        [panelStyle]="{
                            'min-width': reg_form_uuid.el.nativeElement.offsetWidth + 'px',
                            'max-width': reg_form_uuid.el.nativeElement.offsetWidth + 'px'
                        }"
                        id="event-details-registration-form-dropdown">
                      </p-select>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('reg_form_uuid')" name="Registration form"></app-handle-error>
                    </div>
                    <div class="neo-input-wrapper" id="event-details-email-template-wrapper">
                      <label for="email_template">Email Template <span class="required">*</span></label>
                      <p-select 
                        [options]="emailTemplates" 
                        formControlName="email_template_id"
                        optionLabel="name" 
                        optionValue="id"
                        [disabled]="!userPrivileges.has('event.update')"
                        [filter]="true"
                        [filterBy]="'name'"
                        [ngClass]="{'error': clicked && eventDetailsForm.controls['email_template_id'].errors}"
                        placeholder="Choose an email template"
                        appendTo="body"
                        #email_template_id
                        [panelStyle]="{
                            'min-width': email_template_id.el.nativeElement.offsetWidth + 'px',
                            'max-width': email_template_id.el.nativeElement.offsetWidth + 'px'
                        }"
                        id="event-details-email-template-dropdown">
                      </p-select>
                      <app-handle-error [clicked]="clicked" [control]="eventDetailsForm.get('email_template_id')" name="Email template"></app-handle-error>
                    </div>
                  </div>
                  <div class="neo-input-wrapper proctoring-toggle-wrapper" id="event-details-proctoring-wrapper">
                    <div class="proctoring-toggle-row">
                      <div class="proctoring-toggle-text">
                        <span class="proctoring-toggle-label">Enable proctoring</span>
                      </div>
                      <p-toggleswitch inputId="event-details-proctoring" formControlName="enableProctoring"
                        [disabled]="!userPrivileges.has('event.update')"></p-toggleswitch>
                    </div>

                    @if (eventDetailsForm.get('enableProctoring')?.value) {
                    <div class="proctoring-settings">
                      <!-- Each proctoring capability is its own titled block; add future ones below. -->
                      <div class="proctoring-feature">
                        <span class="proctoring-feature-title">Face verification <span class="proctoring-feature-suffix">— For Assessment Stage</span></span>
                        <small class="proctoring-feature-hint">How the candidate's photo is captured during registration.</small>
                        <div class="proctoring-mode-list">
                          <label class="proctoring-mode-item">
                            <p-radioButton name="photoCaptureMode" value="upload" formControlName="photoCaptureMode"
                              [disabled]="!userPrivileges.has('event.update')"></p-radioButton>
                            <span>Upload image</span>
                          </label>
                          <label class="proctoring-mode-item">
                            <p-radioButton name="photoCaptureMode" value="live" formControlName="photoCaptureMode"
                              [disabled]="!userPrivileges.has('event.update')"></p-radioButton>
                            <span>Live capture</span>
                          </label>
                          <label class="proctoring-mode-item">
                            <p-radioButton name="photoCaptureMode" value="both" formControlName="photoCaptureMode"
                              [disabled]="!userPrivileges.has('event.update')"></p-radioButton>
                            <span>Both</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                </div>
            </div>
          </div>
        </div>
        
        <!-- Save Button for Overview -->
        @if (userPrivileges.has('event.update')) {
        <div class="save-button-container" id="event-details-overview-footer">
          <button pButton
            class="create-btn" 
            id="event-details-save-changes-btn"
            [disabled]="saveBtnLoading || !canSaveEventDetails()" 
            [loading]="saveBtnLoading"
            (click)="saveEventDetails()">
            Save Changes
          </button>
        </div>
        }
        }

        <!-- Job Roles Tab -->
        @if (currentTab() === "job-roles") {
        <div class="template-content neo-scrollbar" id="event-details-job-roles-tab">
          <!-- Role Titles Section at Top -->
          <div class="section role-titles-section" id="event-details-role-titles-section">
            <div class="section-content role-titles-content">
              <div class="section-item no-border">
                <div class="section-item-content">
                  <div class="job-roles-tabs" id="event-details-job-roles-tabs">
                    <div class="job-role-tab" 
                      [class.active]="role.isActive" 
                      *ngFor="let role of jobRoleList; let i = index"
                      [id]="'event-details-job-role-tab-' + i"
                      (click)="openRole(role.roleId)">
                      {{role.roleName}}
                    </div>
                  </div>
                </div>
                </div>
            </div>
        </div>

          <div class="job-role-content" id="event-details-job-role-content" *ngIf="roleDetails.name">
            <!-- Job Details Section (Combined) -->
            <div class="section" id="event-details-job-details-section">
              <div class="section-heading" id="event-details-job-details-section-heading">
                Job Details
              </div>
              <div class="section-content">
                <!-- Basic Information -->
                <div class="section-item no-border">
                  <div class="section-item-content">
                    <div class="neo-grid neo-grid-cols-3" id="event-details-role-basic-info-grid">
                      <div class="neo-input-wrapper" id="event-details-role-name-wrapper">
                        <label for="role_name">Role Name <span class="required">*</span></label>
                        <input 
                          pInputText 
                          type="text"
                          id="event-details-role-name-input"
                          [readonly]="!userPrivileges.has('job_role.update')"
                          [value]="roleDetails.name"
                          class="form-input">
                      </div>
                      <div class="neo-input-wrapper" id="event-details-role-type-wrapper">
                        <label for="role_type">Role Type <span class="required">*</span></label>
                        <p-select 
                          [options]="roleTypes" 
                          [(ngModel)]="selectedRoleType"
                          optionLabel="label" 
                          optionValue="value"
                          [disabled]="!userPrivileges.has('job_role.update')"
                          placeholder="Select role type"
                          id="event-details-role-type-dropdown">
                        </p-select>
                      </div>
                      <div class="neo-input-wrapper" id="event-details-work-mode-wrapper">
                        <label for="work_mode">Work Mode <span class="required">*</span></label>
                        <p-select 
                          [options]="workModes" 
                          [(ngModel)]="selectedWorkMode"
                          optionLabel="label" 
                          optionValue="value"
                          [disabled]="!userPrivileges.has('job_role.update')"
                          placeholder="Select work mode"
                          id="event-details-work-mode-dropdown">
                        </p-select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Requirements -->
                <!-- <div class="section-item no-border" id="event-details-requirements-section">
                  <div class="section-item-content" [formGroup]="jobRoleForm">
                    <div class="neo-input-wrapper" id="event-details-requirements-wrapper">
                      <label for="requirement">Requirements</label>
                      <textarea 
                        id="event-details-requirements-textarea"
                        pInputTextarea
                        formControlName="requirement"
                        [readonly]="!userPrivileges.has('job_role.update')"
                        class="form-textarea"
                        rows="3"
                        placeholder="Enter requirements separated by commas">
                      </textarea>
                    </div>
                  </div>
                </div> -->

                <!-- Description -->
                <div class="section-item no-border" id="event-details-description-section">
                  <div class="section-item-content" [formGroup]="jobRoleForm">
                    <div class="neo-input-wrapper" id="event-details-description-wrapper">
                      <div class="description-header">
                        <label for="description">Role Description</label>
                        @if (!editingDescription() && userPrivileges.has('job_role.update')) {
                          <span class="label-action" id="event-details-description-edit-btn" (click)="editDescription()">Edit</span>
                        }
                        @if (editingDescription()) {
                          <span class="label-action" (click)="cancelEditDescription()">Close</span>
                        }
                      </div>
                      @if (!editingDescription()) {
                        <div class="description-display" id="event-details-description-display">
                          <app-innerhtml-view
                            [preview]="roleDetails.description ? (roleDetails.description | getSafeHTMLEmail) : 'No description available'"></app-innerhtml-view>
                        </div>
                      } @else {
                        <textarea 
                          id="event-details-description-editor"
                          placeholder="Enter job description">
                        </textarea>
                      }
                    </div>
                  </div>
                </div>

                <!-- Attachments -->
                <div class="section-item no-border" id="event-details-attachments-section">
                  <div class="section-item-content">
                    <div class="neo-input-wrapper" id="event-details-attachments-wrapper">
                      <label>Attachments</label>
                      <div class="attachments-content">
                        <ng-container *ngIf="roleDetails.attachment; else noAttachment">
                          <div class="attachment-item">
                            <div class="attachment-icon">
                              <i class="pi pi-file-pdf"></i>
                            </div>
                            <div class="attachment-info">
                              <span class="attachment-name">{{getAttachmentName(roleDetails.attachment)}}</span>
                              <span class="attachment-size">{{getAttachmentSize(roleDetails.attachment)}}</span>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #noAttachment>
                          <div class="no-attachment">
                            <i class="pi pi-file"></i>
                            <span>No attachment found</span>
                          </div>
                        </ng-template>
                      </div>
                    </div>
            </div>
                </div>
              </div>
                                  </div>

            <div class="section" id="event-details-location-section">
              <div class="section-heading">
                <div class="section-title-row">
                  <h3 class="section-title" id="event-details-location-section-title">Location Details</h3>
                  <div class="location-controls" id="event-details-location-controls">
                    <div class="neo-input-wrapper">
                      <p-select 
                        style="margin: 0;"
                        big
                        [options]="getLocationOptions()" 
                        [(ngModel)]="selectedLocationIndex"
                        (onChange)="onLocationChange($event)"
                        optionLabel="label" 
                        optionValue="value"
                        placeholder="Select location"
                        class="location-dropdown"
                        id="event-details-location-dropdown"
                        *ngIf="roleDetails.locations?.length > 1">
                      </p-select>
                    </div>
                    <button 
                      *ngIf="userPrivileges.has('job_role.update')"
                      type="button" 
                      class="add-location-btn"
                      id="event-details-add-location-btn"
                      style="flex-shrink: 0;"
                      (click)="addLocation()">
                      Add Location
                    </button>
                    <button 
                      style="flex-shrink: 0;"
                      *ngIf="userPrivileges.has('job_role.update') && roleDetails.locations?.length > 1"
                      type="button" 
                      class="remove-location-btn"
                      id="event-details-remove-location-btn"
                      (click)="removeLocation(selectedLocationIndex)"
                      title="Remove current location">
                      <i class="pi pi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="section-content">
                <div class="section-item no-border">
                  <div class="section-item-content">
                    <div class="location-fields-grid" id="event-details-location-fields-grid">
                      <div class="neo-input-wrapper" id="event-details-country-wrapper">
                        <label for="country">Country <span class="required">*</span></label>
                        <div class="custom-dropdown-container">
                          <input 
                            type="text" 
                            pInputText 
                            [ngModel]="getCurrentLocationData().country"
                            (ngModelChange)="updateLocationField('country', $event)"
                            (click)="countryOverlay.toggle($event)"
                            (input)="filterCountries($event)"
                            class="form-input dropdown-input"
                            placeholder="Search country..." 
                            autocomplete="off"
                            id="event-details-country-input"
                            [readonly]="!userPrivileges.has('job_role.update')" />
                          <i class="pi pi-chevron-down dropdown-icon" (click)="countryOverlay.toggle($event)"></i>
                        </div>
                        <p-popover #countryOverlay styleClass="no-padding-overlay">
                                <ng-template #content>
                            <div class="dropdown-options">
                              <div *ngIf="filteredCountries.length > 0; else noCountryRecords">
                                <div *ngFor="let country of filteredCountries" 
                                     class="dropdown-option"
                                     (click)="countryOverlay.hide(); isUserChangingCountry = true; onCountryChange(country.value); updateLocationField('country', country.value);">
                                  {{ country.label }}
                                </div>
                              </div>
                              <ng-template #noCountryRecords>
                                <div class="no-records">No countries found</div>
                              </ng-template>
                                  </div>
                                </ng-template>
                              </p-popover>
                      </div>
                      <div class="neo-input-wrapper" id="event-details-state-wrapper">
                        <label for="state">State <span class="required">*</span></label>
                        <div class="custom-dropdown-container">
                          <input 
                            type="text" 
                            pInputText 
                            [ngModel]="getCurrentLocationData().state"
                            (ngModelChange)="updateLocationField('state', $event)"
                            (click)="stateOverlay.toggle($event)"
                            (input)="filterStates($event)"
                            class="form-input dropdown-input"
                            placeholder="Search state..." 
                            autocomplete="off"
                            id="event-details-state-input"
                            [readonly]="!userPrivileges.has('job_role.update')" />
                          <i class="pi pi-chevron-down dropdown-icon" (click)="stateOverlay.toggle($event)"></i>
                        </div>
                        <p-popover #stateOverlay styleClass="no-padding-overlay">
                          <ng-template #content>
                            <div class="dropdown-options">
                              <div *ngIf="filteredStates.length > 0; else noStateRecords">
                                <div *ngFor="let state of filteredStates" 
                                     class="dropdown-option"
                                     (click)="stateOverlay.hide(); onStateChange(state.value, getCurrentLocationData().country); updateLocationField('state', state.value);">
                                  {{ state.label }}
                                </div>
                              </div>
                              <ng-template #noStateRecords>
                                <div class="no-records">No states found</div>
                              </ng-template>
                            </div>
                    </ng-template>
                        </p-popover>
                      </div>
                      <div class="neo-input-wrapper" id="event-details-city-wrapper">
                        <label for="city">City <span class="required">*</span></label>
                        <div class="custom-dropdown-container">
                          <input 
                            type="text" 
                            pInputText 
                            [ngModel]="getCurrentLocationData().city"
                            (ngModelChange)="updateLocationField('city', $event)"
                            (click)="cityOverlay.toggle($event)"
                            (input)="filterCities($event)"
                            class="form-input dropdown-input"
                            placeholder="Search city..." 
                            autocomplete="off"
                            id="event-details-city-input"
                            [readonly]="!userPrivileges.has('job_role.update')" />
                          <i class="pi pi-chevron-down dropdown-icon" (click)="cityOverlay.toggle($event)"></i>
                        </div>
                        <p-popover #cityOverlay styleClass="no-padding-overlay">
                          <ng-template #content>
                            <div class="dropdown-options">
                              <div *ngIf="filteredCities.length > 0; else noCityRecords">
                                <div *ngFor="let city of filteredCities" 
                                     class="dropdown-option"
                                     (click)="cityOverlay.hide(); updateLocationField('city', city.value);">
                                  {{ city.label }}
                                </div>
                              </div>
                              <ng-template #noCityRecords>
                                <div class="no-records">No cities found</div>
                              </ng-template>
                            </div>
                          </ng-template>
                        </p-popover>
                      </div>
                      <div class="neo-input-wrapper" id="event-details-business-unit-wrapper">
                        <label for="business_unit">Business Unit <span class="required">*</span></label>
                        <input 
                          pInputText 
                          type="text"
                          id="event-details-business-unit-input"
                          [readonly]="!userPrivileges.has('job_role.update')"
                          [ngModel]="getCurrentLocationData().business_unit"
                          (ngModelChange)="updateLocationField('business_unit', $event)"
                          class="form-input">
                      </div>
                      <div class="neo-input-wrapper" id="event-details-openings-wrapper">
                        <label for="openings">Openings</label>
                        <input 
                          pInputText 
                          type="number"
                          id="event-details-openings-input"
                          [readonly]="!userPrivileges.has('job_role.update')"
                          [value]="getLocationFieldValue(locationDetails[0], 'opening')"
                          class="form-input">
                      </div>
                      <div class="neo-input-wrapper" id="event-details-max-applicant-wrapper">
                        <label for="max_applicant">Maximum Applicants</label>
                        <input 
                          pInputText 
                          type="number"
                          id="event-details-max-applicant-input"
                          [readonly]="!userPrivileges.has('job_role.update')"
                          [value]="getLocationFieldValue(locationDetails[0], 'max_applicant')"
                          class="form-input">
                      </div>
                      <div class="neo-input-wrapper" id="event-details-diversity-male-wrapper">
                        <label for="diversity_male">Diversity Male</label>
                        <input 
                          pInputText 
                          type="number"
                          id="event-details-diversity-male-input"
                          [readonly]="!userPrivileges.has('job_role.update')"
                          [value]="getLocationFieldValue(locationDetails[0], 'diversity_male')"
                          class="form-input">
                      </div>
                      <div class="neo-input-wrapper" id="event-details-diversity-female-wrapper">
                        <label for="diversity_female">Diversity Female</label>
                        <input 
                          pInputText 
                          type="number"
                          id="event-details-diversity-female-input"
                          [readonly]="!userPrivileges.has('job_role.update')"
                          [value]="getLocationFieldValue(locationDetails[0], 'diversity_female')"
                          class="form-input">
                      </div>
                      <div class="neo-input-wrapper" id="event-details-diversity-other-wrapper">
                        <label for="diversity_other">Diversity Other</label>
                        <input 
                          pInputText 
                          type="number"
                          id="event-details-diversity-other-input"
                          [readonly]="!userPrivileges.has('job_role.update')"
                          [value]="getLocationFieldValue(locationDetails[0], 'diversity_other')"
                          class="form-input">
                      </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>

        <!-- Save Button for Job Roles -->
        @if (userPrivileges.has('job_role.update')) {
        <div class="save-button-container" id="event-details-job-roles-footer">
          <button pButton
            class="create-btn" 
            id="event-details-save-job-role-btn"
            [disabled]="saveBtnLoading || !checkJobRoleChanges()" 
            [loading]="saveBtnLoading"
            (click)="saveJobRoleDetails()">
            Save Changes
          </button>
        </div>
        }
        }

        <!-- Access Management Tab -->
        @if (currentTab() === "access-management") {
        <div class="template-content neo-scrollbar" id="event-details-access-management-tab">
          <div class="section" id="event-details-access-management-section">
            <div class="section-heading">
              <div class="section-title-row">
                <h3 class="section-title" id="event-details-access-management-section-title">Access Management Details</h3>
                <button *ngIf="userPrivileges.has('event_access_management.update') && assignedUsers.length > 0" 
                  class="assign-role-btn"
                  id="event-details-assign-role-btn"
                  (click)="openAssignUserDialog()">
                  Assign Role
                </button>
              </div>
            </div>
            <div class="section-content">
              <div class="section-item no-border">
                <div class="access-management-content">
                  
                  <!-- Empty State with SVG -->
                  <div *ngIf="assignedUsers.length === 0 && !isLoading" class="empty-state" id="event-details-access-management-empty-state">
                    <div class="empty-state-illustration">
                      <img src="assets/access-management.svg" alt="Access Management" class="access-management-svg">
                    </div>
                    <h2>Reducing the risk of unauthorized access.</h2>
                    <p>It ensures that only authorized users can access specific features, data, or areas based on their roles and permissions.</p>
                    <button *ngIf="userPrivileges.has('event_access_management.update')" 
                      class="assign-role-btn"
                      id="event-details-empty-state-assign-role-btn"
                      (click)="openAssignUserDialog()">
                      Assign Role
                    </button>
                  </div>
                  
                  <!-- User Cards Grid -->
                  <div *ngIf="assignedUsers.length > 0 && !isLoading" class="users-grid" id="event-details-users-grid">
                    <div *ngFor="let user of assignedUsers; let i = index" class="user-card" [id]="'event-details-user-card-' + i">
                      <div class="user-profile-picture">
                        <img [src]="user.profilePicture || getDefaultProfilePicture(user)" 
                             [alt]="user.name" 
                             class="profile-image">
                      </div>
                      <div class="user-name">{{user.name}}</div>
                      <div class="user-email">{{user.email}}</div>
                      <div class="user-role">
                        <span class="role-badge" [ngClass]="'role-' + user.role.toLowerCase().replace(' ', '-')">
                          {{user.role}}
                        </span>
                      </div>
                      <button *ngIf="userPrivileges.has('event_access_management.update')" 
                        class="remove-user-btn"
                        [id]="'event-details-remove-user-btn-' + i"
                        (click)="confirmDeleteMember(user)"
                        [disabled]="isDeletingMember">
                        <img src="assets/remove.svg" alt="Remove" class="remove-icon">
                        Remove
                      </button>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>


<!-- Role Add Sidebar -->
    <div *ngIf="showAddRole">
        <p-drawer  
            [(visible)]="showAddRole" 
            position="right"
            [style]="{ width: '50vw' }" 
            [modal]="true"
            [dismissible]="false"
            [closeOnEscape]="true"
            styleClass="p-drawer-lg add-role-sidebar"
            (onHide)="getEventDetails();">
            <div class="sidebar-content">
                <app-role-add 
                    [data]="preparedRoleData" 
                    (roleUpdated)="onRoleUpdateSuccess()"
                    (closeAddRole)="showAddRole = false">
                </app-role-add>
            </div>
        </p-drawer>
    </div>

<!-- Assign User Dialog -->
<p-dialog 
  [visible]="showAssignUserDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px' }"
  [baseZIndex]="10000"
  styleClass="neo-dialog assign-role-dialog"
  id="event-details-assign-user-dialog">
  
  <div class="dialog-wrapper">
    <!-- Dialog Loading Overlay -->
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">Assign Role</h2>
      <button 
        type="button" 
        class="dialog-close-btn"
        id="event-details-assign-user-dialog-close-btn"
        (click)="closeAssignUserDialog()"
        aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
            </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <div class="assign-user-center">
          <div class="assign-user-card">
            <div class="assign-user-content">
        <div class="neo-input-wrapper">
          <label required>Role</label>
            <p-select 
              class="form-dropdown"
              placeholder="Select a role"
              optionLabel="name"
              optionValue="id"
              [(ngModel)]="selectedRoleForAssignment"
              (onChange)="onRoleSelectionChange($event)"
              [options]="availableRoles"
              [showClear]="false"
              id="event-details-assign-role-dropdown">
            </p-select>
        </div>

        <div class="neo-input-wrapper">
          <label required>Users</label>
          <p-multiselect 
            styleClass="form-multiselect"
            [ngClass]="{'focused': selectedUsers.length > 0}"
            placeholder="Search and select users"
            optionLabel="name"
            optionValue="id"
            [options]="availableUsersForRole"
            [(ngModel)]="selectedUsers"
            [filter]="true"
            display="chip"
            id="event-details-assign-users-multiselect">
          </p-multiselect>
            </div>

        <!-- Users List -->
        <div class="users-list-container" id="event-details-users-list-container" *ngIf="selectedRoleForAssignment && availableUsersForRole.length > 0">
          <div *ngIf="assignDialogLoading" class="dialog-loading-overlay center-loader">
            <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
            </p-progressSpinner>
          </div>
          <div class="users-list" id="event-details-users-list">
            <div class="user-item" 
                 *ngFor="let user of availableUsersForRole; trackBy: trackByUserId; let i = index"
                 [id]="'event-details-user-item-' + i"
                 (click)="toggleUserSelection(user.id)"
                 [class.selected]="selectedUsers.includes(user.id)"
                 [class.disabled]="selectedUsers.length > 0 && !selectedUsers.includes(user.id)">
              <div class="user-avatar">
                <span>{{user.initials}}</span>
                </div>
              <div class="user-info">
                <span class="user-name">{{user.name}}</span>
                <span class="user-email">{{user.email}}</span>
                              </div> 
                        </div>
                    </div>
                </div>

        <!-- No Users Found Message -->
        <div class="no-users-found" id="event-details-no-users-found" *ngIf="selectedRoleForAssignment && availableUsersForRole.length === 0 && !assignDialogLoading">
          <div class="no-users-icon">
            <i class="pi pi-users"></i>
          </div>
          <h4>No users found</h4>
          <p>No available users found for the selected role.</p>
        </div>
        <div class="no-users-found" *ngIf="!selectedRoleForAssignment && !assignDialogLoading">
          <div class="no-users-icon">
            <i class="pi pi-info-circle"></i>
          </div>
          <h4>Select a role to view users</h4>
        </div>
            </div>
            </div>
        </div>
    </div>
</div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button 
        pButton 
        pRipple 
        type="button"
        label="Cancel"
        class="cancel-btn"
        id="event-details-assign-user-cancel-btn"
        (click)="closeAssignUserDialog()">
      </button>
      <button 
        pButton 
        pRipple 
        type="button"
        label="Add User"
        class="send-invite-btn"
        id="event-details-assign-user-add-btn"
        [disabled]="selectedUsers.length === 0 || !selectedRoleForAssignment"
        (click)="assignUsers()">
      </button>
    </div>
</div>
</p-dialog>

<!-- Delete Member Confirmation Modal -->
<div class="modal-backdrop" id="event-details-delete-member-modal-backdrop" *ngIf="showDeleteMemberModal" (click)="closeDeleteMemberModal()">
  <div class="modal-container delete-member-modal" id="event-details-delete-member-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Remove Member</h3>
      <button type="button" class="close-btn" id="event-details-delete-member-close-btn" (click)="closeDeleteMemberModal()">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="warning-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <p class="confirmation-text">
        Are you sure want to remove <strong>{{ memberToDelete?.name }}</strong>?
      </p>
      <p class="sub-text">This action cannot be undone.</p>
    </div>
    <div class="modal-footer">
      <button type="button"
        class="btn btn-secondary"
        id="event-details-delete-member-cancel-btn"
        (click)="closeDeleteMemberModal()"
        [disabled]="isDeletingMember">
        Cancel
      </button>
      <button type="button"
        class="btn btn-danger"
        id="event-details-delete-member-confirm-btn"
        (click)="removeUser(memberToDelete)"
        [disabled]="isDeletingMember">
        <span *ngIf="isDeletingMember" class="spinner"></span>
        {{ isDeletingMember ? 'Removing...' : 'Remove Member' }}
      </button>
    </div>
  </div>
</div>

<p-toast></p-toast>